import { SetCashFloatFormController as controller } from './set-cash-float-form.controller'
import template from './set-cash-float-form.html'

/**
 * Component for the form allowing the user to set the amount and note for the opening cash float.
 *
 * @param {Form} form
 *        The form model (what you normally set as the `name` property of a form)
 *
 * @param {Boolean} loading
 *        Whether or not the form is currently waiting for a server response - will disable form fields etc
 *
 * @param {String} formId
 *        The ID to set on the form element - for associating buttons that aren't transcluded inside the form
 *
 * @param {Event} onSubmit
 *        Event emitted when the form is submitted. The `$event` parameter will have a property `cashFloatSettings`
 *        containing the `amount`, `note`, and `type` of the cash movement.
 */
export const SetCashFloatFormComponent = {
  bindings: {
    form: '=',
    loading: '<',
    formId: '@',
    onSubmit: '&',
  },
  controller,
  template,
  transclude: true,
}
